import { Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { MediumCustomIcon } from "../../layer00";

type HistoricalConversationListItemProps = {
  createdAt: string;
  content: string;
  isCheckIn?: boolean;
  onClick?: () => void;
};

export const HistoricalConversationListItem = (
  props: HistoricalConversationListItemProps
) => {
  const theme = useTheme();

  // API returns MySQL-format datetimes ("yyyy-MM-dd HH:mm:ss") as well as
  // proper ISO strings ("yyyy-MM-ddTHH:mm:ssZ"). Normalise to ISO before
  // parsing so both formats produce a valid DateTime.
  const conversationTime = DateTime.fromISO(
    props.createdAt.replace(" ", "T")
  );
  const formattedTime = conversationTime.toFormat("MMM dd");

  return (
    <Stack
      rowGap=".125rem"
      onClick={props.onClick}
      sx={
        props.onClick
          ? { cursor: "pointer", "&:hover": { opacity: 0.8 } }
          : undefined
      }
    >
      <Stack direction="row" alignItems="center" columnGap=".375rem">
        <MediumCustomIcon
          icon={props.isCheckIn ? "FLAG" : "CHAT"}
          stroke={
            props.isCheckIn
              ? theme.palette.warning.main
              : theme.palette.primary.dark
          }
          width={14}
          height={14}
        />
        <Typography variant="chatSender">{formattedTime}</Typography>
      </Stack>
      <Typography
        variant="chatMessageBody"
        sx={{
          maxWidth: "inherit",
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.content}
      </Typography>
    </Stack>
  );
};
